
<template>

    <div class="Navbar">
        <b-navbar class="nav" type="dark" variant="dark">
            <b-link href="" class="navbar-brand link mx-auto">
                { Mohil Palav }
            </b-link>
        </b-navbar>
    </div>

</template>

<script>
    export default{};
</script>

<style lang="scss" scoped>
.Navbar {
    @import url('https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap');

    .nav {
        position: relative;
        width: 100%;
        font-family: 'Bree Serif', serif;
        font: 200;
    }
    .link {
        color: white;
        text-decoration: none;
    }
}


</style>
